import React from 'react'

import classNames from 'classnames'

import { getImageInfo } from './getImageInfo'
import type { ImageInfo } from './getImageInfo'

import styles from './style.module.scss'

export { getImageInfo } from './getImageInfo'
export type { ImageInfo } from './getImageInfo'

interface FTIconProps {
  fileName?: string
  fileType?: string
  size?: number
  className?: string
}

interface FTIconState {
  imgSrc: string
  text: string | null
  size: number | null
  alt: string
}

class FTIcon extends React.Component<FTIconProps, FTIconState> {
  state: FTIconState = {
    imgSrc: '',
    text: null,
    size: null,
    alt: '',
  }

  componentDidMount(): void {
    this.applyProps()
  }

  componentDidUpdate(prevProps: FTIconProps): void {
    const { fileName, fileType, size } = this.props

    if (
      fileName !== prevProps.fileName ||
      fileType !== prevProps.fileType ||
      size !== prevProps.size
    ) {
      this.applyProps()
    }
  }

  componentWillUnmount(): void {}

  applyProps = (): void => {
    const { fileName, fileType, size } = this.props

    // console.log(fileName, fileType, size)

    let info: ImageInfo | null = null
    let text: string | null = null
    let alt = 'file'
    if (fileName != null) {
      const pos = fileName.lastIndexOf('.')
      const ext = fileName.substring(pos + 1)
      info = this.getImageInfo(ext)
      alt = ext
      text = info.type === 'general' ? ext : null
    } else if (fileType != null) {
      info = this.getImageInfo(fileType)
      text = info.type === 'general' ? fileType : null
      alt = fileType
    } else {
      info = this.getImageInfo('')
    }

    this.setState({
      imgSrc: info.path,
      text,
      size,
      alt,
    })
  }

  getImageInfo = (fileType: string): ImageInfo => {
    return getImageInfo(fileType)
  }

  render(): React.ReactNode {
    const { imgSrc, /* text, */ size, alt } = this.state
    const { className } = this.props

    const styleProps: React.CSSProperties = {}
    if (size != null) {
      styleProps.width = size
    }

    return (
      <div className={classNames(styles.ftIcon, 'ftIcon', className)}>
        <img src={imgSrc} style={styleProps} alt={alt} />
      </div>
    )
  }
}

export default FTIcon
